// extracted by mini-css-extract-plugin
module.exports = {"body":"PokerPageStylesheet_body__VrycX","pokerPageContainer":"PokerPageStylesheet_pokerPageContainer__zPoM_","confettiCanvas":"PokerPageStylesheet_confettiCanvas__2NAbZ"};